import { Navigate, Outlet } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usePermissionContext } from '@/context/permission-provider';

interface AdminProtectedRouteProps {
  children?: React.ReactNode;
  fallbackPath?: string;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ 
  fallbackPath = '/console' 
}) => {
  const { isAdmin, isInitialized } = usePermissionContext();

  if (!isInitialized || isAdmin === null) {
    return (
      <div className="flex items-center justify-center h-full">
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center h-full">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Access Denied</CardTitle>
          </CardHeader>
          <CardContent>
            <p>You must be an admin to access this page.</p>
            <div className="mt-4">
              <Navigate to={fallbackPath} replace />
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
};

export default AdminProtectedRoute;